import React, { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import { DatalistLaboratories } from '../../components/DatalistLaboratories'
import { GLOBALS } from '../../utils/Globals'
import { LaboratoryService } from '../../services/Laboratory'
import { Context } from '../../Context'
import { Layout } from '../../components/Layout'

export const LaboratoriesList = () => {
  const { isAuth: token,userLogged  } = useContext(Context)
  const dt = useRef(null)

  const isAdmin = () => {
    const rolLogged = userLogged.role;
    if(rolLogged === 'S')
    {
      return true
    }
  }

  const isCreator = () => {
    const rolLogged = userLogged.role;

    if (rolLogged === 'C') {
      return true
    }
  }

  const columns = [
  /*{
      field: 'id',
      header: 'ID',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por ID',
    },*/
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Nombre de Laboratorio',
    },
    {
        field: 'description',
        header: 'Descripción',
        sortable: true,
        filter: true,
        filterPlaceholder: 'Buscar por descripcion',
      },
      {
        field: 'status',
        header: 'Estado',
        sortable: true,
        filter: true,
        filterPlaceholder: 'Buscar por descripcion',
      },
  ]

  const customActionButtons = ({ row }) => {
    return (
      <Link to={`${GLOBALS.menu.laboratories.viewlaboratory}/${row.id}`}>
        <Button
          type="button"
          icon="pi pi-chevron-circle-right"
          className="p-button-primary"
          tooltip="Ver"
        ></Button>
      </Link>
    )
  }

  return (
    <Layout>
      <DatalistLaboratories
        ref={dt}
        menuItem={GLOBALS.menu.laboratories}
        listItems={() => isAdmin() || isCreator() ? LaboratoryService.getAll(token):LaboratoryService.getlaboratoriesxAllUser(userLogged.id,token)}
        bulkDelete={(ids) => LaboratoryService.bulkDelete(ids, token)}
        columns={columns}
        customActionButtons={customActionButtons}
      ></DatalistLaboratories>
    </Layout>
  )
}
